import { useStyletron } from '@thanx/uikit/theme'
import { providerLogo } from './providerLogos'

type Props = {
  logoKey: string | null
  label: string
  size?: number
  iconOnly?: boolean
}

const ProviderLogo = ({
  logoKey,
  label,
  size = 20,
  iconOnly = false,
}: Props) => {
  const [css] = useStyletron()
  const src = providerLogo(logoKey)
  // Without a logo asset, the icon can't stand alone -- fall back to the
  // visible label so the cell isn't blank.
  const hideLabel = iconOnly && !!src

  return (
    <div className={css({ display: 'flex', alignItems: 'center', gap: '6px' })}>
      {src && (
        <img
          src={src}
          alt=""
          aria-hidden="true"
          className={css({
            // Logo marks ship at varying aspect ratios (a wide wordmark vs a
            // near-square icon), so sizing by width+height would squash the
            // wider ones -- fix the height and let width scale naturally.
            height: `${size}px`,
            width: 'auto',
            maxWidth: `${size * 3}px`,
            objectFit: 'contain',
            flexShrink: 0,
          })}
        />
      )}
      <span className={hideLabel ? 'sr-only' : undefined}>{label}</span>
    </div>
  )
}

export default ProviderLogo
